import { useQuery } from "@tanstack/react-query";
import type { AddressField } from "../types";
import { useAddressFieldsApi } from "../address-fields-api-context";
import { DEFAULT_ADDRESS_FIELDS } from "../country-config";
import { addressFieldsKeys } from "../query-keys";

export function useAddressFields(
  countryCode: string,
  languageIso?: string,
): {
  addressFields: AddressField[];
  isLoadingAddressFields: boolean;
} {
  const api = useAddressFieldsApi();

  const { data, isLoading } = useQuery({
    queryKey: addressFieldsKeys.byCountry(countryCode, languageIso),
    queryFn: () => api.fetchAddressFields(countryCode, languageIso),
    staleTime: Infinity,
    enabled: !!countryCode,
  });

  const addressFields: AddressField[] =
    (data?.address_fields?.fields as AddressField[] | undefined) ??
    DEFAULT_ADDRESS_FIELDS;

  return {
    addressFields,
    isLoadingAddressFields: isLoading,
  };
}
